import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage';

import {
  getValidEventType,
  isClassicOnlyEventTypeSport,
} from '#src/lib/so5.ts';

export const useLastVisitedEventType = () => {
  const { sport } = useSportContext();
  const [lastVisitedEventType, setLastVisitedEventType] = useLocalStorage(
    'lastVisitedEventType',
    So5FixtureEvent.DAILY.toLowerCase()
  );

  // So lastVisitedEventType is normalized and always in lowercase
  const formattedSetLastVisitedEventType = (
    eventType: So5FixtureEvent | string
  ) => {
    setLastVisitedEventType(eventType.toLowerCase());
  };

  const validEventType = getValidEventType(lastVisitedEventType);

  if (lastVisitedEventType !== validEventType.toLowerCase()) {
    formattedSetLastVisitedEventType(So5FixtureEvent.CLASSIC);
  }

  return {
    lastVisitedEventType: isClassicOnlyEventTypeSport(sport)
      ? So5FixtureEvent.CLASSIC.toLowerCase()
      : lastVisitedEventType,
    setLastVisitedEventType: formattedSetLastVisitedEventType,
  };
};
